import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useSEO } from "@/hooks/use-seo";
import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, Mail, MessageCircle,
  Calendar, Lock, Users, Trophy, Zap, AlertTriangle, Globe, ShoppingBag
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo20 from "@assets/logos_extracted/20.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://nmn.fynkelto.com/?mid=279656_1645825";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const pros = [
  "Originální a zábavné téma s animovaným ovocem",
  "Výběr z několika uvítacích bonusů a štědré průběžné akce",
  "VIP program s cashbackem až 15 % (do 75 000 Kč) a Live Casino cashback 25 %",
  "Více než 19 metod vkladu a 21 metod výběru – nejvíce ze všech recenzovaných kasin",
  "Coins systém – plňte úkoly a směňte mince za bonusy v interním Obchodě",
];

const cons = [
  "Chybí mobilní aplikace – pouze responzivní web",
  "Platební metody nejsou na webu veřejně uvedeny",
  "Stránky mohou působit méně seriózně kvůli odlehčenému stylu",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-48 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč (500 Kč pro plný uvítací bonus)</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>E-peněženky / krypto:</span><span className={valueClass}>Do 24 hodin (někdy okamžitě)</span></div>
        <div className={rowClass}><span className={labelClass}>Karty / bankovní převod:</span><span className={valueClass}>2–5 pracovních dní (obvykle 2–3 dny)</span></div>
        <div className={rowClass}><span className={labelClass}>Poplatky:</span><span className={valueClass}>Žádné ze strany kasina</span></div>
        <div className={rowClass}><span className={labelClass}>Metody vkladu (19):</span><span className={valueClass}>Visa, Mastercard, Paysafecard, CashtoCode, Neosurf, Skrill, Skrill 1-Tap, Neteller, MiFinity, eZeeWallet, EcoPayz, bankovní převod, Bitcoin, Litecoin, Ethereum, Ripple (XRP), USDT a další</span></div>
        <div className={rowClass}><span className={labelClass}>Metody výběru (21):</span><span className={valueClass}>Skrill, Neteller, Skrill 1-Tap, eZeeWallet, MiFinity, Visa, Mastercard, bankovní převod, Bitcoin, Litecoin, Ethereum, Ripple, USDT a další</span></div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Celkový počet her:</span><span className={valueClass}>9 000+</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>8 500+</span></div>
        <div className={rowClass}><span className={labelClass}>Ruleta:</span><span className={valueClass}>100+ variant</span></div>
        <div className={rowClass}><span className={labelClass}>Blackjack:</span><span className={valueClass}>100+ variant (206 stolů v live sekci)</span></div>
        <div className={rowClass}><span className={labelClass}>Hry s živými dealery:</span><span className={valueClass}>270+ přenosů</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní disciplíny:</span><span className={valueClass}>27 sportů včetně Live Betting</span></div>
        <div className={rowClass}><span className={labelClass}>Pay N Play:</span><span className={valueClass}>Ano – rychlý přístup bez registrace</span></div>
        <div className={rowClass}><span className={labelClass}>Klíčoví poskytovatelé:</span><span className={valueClass}>NetEnt, Play'n GO, Pragmatic Play, Evolution, Microgaming, Red Tiger, Nolimit City, Yggdrasil, Push Gaming, Quickspin, Ezugi, Hacksaw Gaming, ELK Studios, Playson, Relax Gaming, Playtech a další</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Dostupnost:</span><span className={valueClass}>24/7 (live chat s reálnými operátory)</span></div>
        <div className={rowClass}><span className={labelClass}>Live chat:</span><span className={valueClass}>Odpověď obvykle do 1 minuty</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@nomini.com (cca 45 minut)</span></div>
        <div className={rowClass}><span className={labelClass}>Telefon:</span><span className={valueClass}>Není dostupný</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky podpory:</span><span className={valueClass}>Angličtina, Finština, Němčina, Polština, Italština, Maďarština, Norština, Portugalština, Španělština, Čeština, Francouzština</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Rok spuštění:</span><span className={valueClass}>2019</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>7StarsPartners</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan</span></div>
        <div className={rowClass}><span className={labelClass}>Platformy:</span><span className={valueClass}>PC, mobilní prohlížeč (bez aplikace)</span></div>
        <div className={rowClass}><span className={labelClass}>Přijímané měny:</span><span className={valueClass}>Kč, EUR, USD, AUD, BRL, CAD, NOK, NZD, CHF, PLN, HUF, INR, PEN, ZAR, CLP</span></div>
        <div className={rowClass}><span className={labelClass}>Čeština:</span><span className={valueClass}>Ano – web i podpora</span></div>
        <div className={rowClass}><span className={labelClass}>Česká republika:</span><span className={valueClass}>Přístup povolen</span></div>
        <div className={rowClass}><span className={labelClass}>FunID registrace:</span><span className={valueClass}>Ano – rychlá registrace bez formuláře</span></div>
        <div className={rowClass}><span className={labelClass}>Demo režim:</span><span className={valueClass}>Ano – většina her dostupná zdarma</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        {([
          ["Deposit limity:", "Nastavitelné v profilu"],
          ["Sebevyloučení:", "Ano"],
          ["KYC ověření:", "Povinné před výběrem – nutno ověřit totožnost, e-mail a telefon"],
          ["Demo režim:", "Dostupný pro většinu her"],
          ["Věková hranice:", "18+"],
          ["Licence:", "Anjouan (ne česká regulace MF ČR)"],
        ] as [string, string][]).map(([label, value]) => (
          <div key={label} className={rowClass}>
            <span className={labelClass}>{label}</span>
            <span className={valueClass}>{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function NominiPage() {
  useSEO({ title: "Nomini Casino Recenze 2026 – Bonus 200 % a hodnocení | HrajBonus", description: "Recenze Nomini Casino. Moderní kasino s velkým výběrem her, bonusem až 200 %, rychlými platebními metodami. Hodnocení 8.7/10. 18+",
  url: "https://hrajbonus.com/kasina/nomini", });

  const [activeTab, setActiveTab] = useState("hry");

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo20} alt="Nomini Casino logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Recenze Kasina Nomini</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 15/02/2026</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <div className="relative w-5 h-5">
                      <Star className="w-5 h-5 text-[#f5c518]/30 absolute inset-0" />
                      <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                        <Star className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                      </div>
                    </div>
                  </div>
                  <span className="text-white font-bold text-xl">9.0</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Celkem her",      value: "9 000+" },
                    { label: "Sporty",          value: "27 disciplín" },
                    { label: "Minimální vklad", value: "250 Kč" },
                    { label: "Live dealer",     value: "270+ stolů" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Animované ovoce</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Pay N Play</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Coins + Obchod odměn</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">VIP cashback 15 %</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Čeština + Kč</span>
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Web i podpora v češtině · Přijímá Kč · Přístup z ČR povolen
                </div>
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus (non-sticky)</div>
                  <div className="text-white font-black text-2xl leading-tight">až 12 500 Kč</div>
                  <div className="text-[#f5c518] font-bold text-base">+ 200 free spinů + Bonus Crab</div>
                  <div className="text-white/50 text-xs mt-1">Wager 35× bonus · Wager 40× FS · Max. sázka 125 Kč</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="Nomini" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">9.0</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Recenze Kasina Nomini</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Nomini Casino vstoupilo na trh v roce 2019 pod skupinou 7StarsPartners a okamžitě zaujalo svým originálním tématem s animovaným ovocem a kreslené animace. Platforma vychází vstříc jak nováčkům díky snadné registraci a demo režimu, tak zkušeným hráčům prostřednictvím VIP programu s cashbackem až 15 % a bohatého kampaňového kalendáře.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* About */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">Proč si Nomini Casino zamilujete?</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Nomini Casino vychází vstříc nováčkům i zkušeným hráčům. Pro začátečníky je připravena snadná registrace, nízký minimální vklad od 250 Kč a možnost vyzkoušet si většinu automatů zdarma v demo režimu.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Věrné a aktivní hráče zase potěší VIP program s exkluzivními bonusy, pravidelné turnaje a slosování o hodnotné ceny.
                </p>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-5">
                  {[
                    { label: "Animované ovoce",   desc: "Originální vizuální identita – přátelská a zábavná atmosféra" },
                    { label: "Pay N Play",         desc: "Rychlý přístup bez standardní registrace" },
                    { label: "FunID registrace",   desc: "Alternativní rychlá registrace bez vyplňování formuláře" },
                    { label: "Demo režim",         desc: "Většina her dostupná zdarma bez registrace" },
                    { label: "Coins + Obchod",     desc: "Plňte úkoly, sbírejte mince a směňte je za bonusy" },
                    { label: "27 sportů",          desc: "Plná sázková sekce včetně Live Betting a turnajů" },
                  ].map(({ label, desc }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="font-semibold text-gray-900 text-xs mb-1">{label}</div>
                      <div className="text-gray-600 text-xs leading-relaxed">{desc}</div>
                    </div>
                  ))}
                </div>

                <div className="bg-amber-50 border border-amber-300 rounded-xl p-4 flex gap-3">
                  <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <p className="text-amber-700 text-sm leading-relaxed">
                    Nomini Casino provozuje svou činnost na základě licence Anjouan. Nejde o licenci vydanou Ministerstvem financí ČR – právní ochrana pro české hráče se proto liší od lokálně regulovaných operátorů.
                  </p>
                </div>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy &amp; Akce v Nomini Casino</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Nomini Casino nabízí celou řadu štědrých bonusů. Noví hráči mohou využít uvítací nabídku, zatímco pro ty stávající jsou připraveny reload bonusy, cashbacky a turnaje.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mb-5">
                  <div className="bg-[#f0f5ff] border border-[#003da5]/20 rounded-xl p-4">
                    <div className="text-[#003da5] font-black text-lg mb-0.5">Uvítací bonus</div>
                    <div className="text-gray-900 font-bold text-base mb-1">100% až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm mb-0.5">+ 200 free spinů</div>
                    <div className="text-[#c9960f] font-semibold text-sm mb-2">+ 1 Bonus Crab</div>
                    <div className="text-gray-400 text-xs space-y-0.5">
                      <div>Non-sticky · Wager 35× bonus</div>
                      <div>Wager 40× FS · Max. sázka 125 Kč</div>
                      <div>Min. vklad 500 Kč (při 250 Kč jen Bonus Crab)</div>
                      <div>Platnost 10 dní od aktivace</div>
                    </div>
                  </div>
                  <div className="space-y-2.5">
                    <div className="bg-[#f3f6fb] border border-[#dde4ee] rounded-xl p-3">
                      <div className="text-gray-700 font-bold text-sm mb-0.5">Sport bonus</div>
                      <div className="text-gray-900 font-bold">100% až 2 500 Kč</div>
                      <div className="text-gray-400 text-xs mt-0.5">Na první sportovní vklad</div>
                    </div>
                    <div className="bg-[#f3f6fb] border border-[#dde4ee] rounded-xl p-3">
                      <div className="text-gray-700 font-bold text-sm mb-0.5">Reload Po–St</div>
                      <div className="text-gray-900 font-bold">50 free spinů</div>
                      <div className="text-gray-400 text-xs mt-0.5">Každé pondělí až středu</div>
                    </div>
                    <div className="bg-[#f3f6fb] border border-[#dde4ee] rounded-xl p-3">
                      <div className="text-gray-700 font-bold text-sm mb-0.5">Víkendový reload</div>
                      <div className="text-gray-900 font-bold">50% až 17 500 Kč + 50 FS</div>
                      <div className="text-gray-400 text-xs mt-0.5">Každý víkend</div>
                    </div>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-3 mb-5">
                  <div className="bg-[#f3f6fb] border border-[#dde4ee] rounded-xl p-3">
                    <div className="text-gray-700 font-bold text-sm mb-0.5">VIP cashback</div>
                    <div className="text-gray-900 font-bold">Až 15 % (do 75 000 Kč)</div>
                    <div className="text-gray-400 text-xs mt-0.5">Pravidelný cashback pro VIP hráče</div>
                  </div>
                  <div className="bg-[#f3f6fb] border border-[#dde4ee] rounded-xl p-3">
                    <div className="text-gray-700 font-bold text-sm mb-0.5">Live Casino cashback</div>
                    <div className="text-gray-900 font-bold">25% až 5 000 Kč</div>
                    <div className="text-gray-400 text-xs mt-0.5">Speciální cashback pro živé kasino</div>
                  </div>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-4">
                  <div className="font-bold text-green-800 text-sm mb-1.5">Co je non-sticky bonus?</div>
                  <p className="text-green-700 text-sm leading-relaxed">
                    U nelepivých bonusů jsou reálné výhry odděleny od bonusových prostředků. Pokud vyhrajete ze svého vlastního vkladu ještě před splněním wageru, tyto reálné výhry lze vybrat – výrazně hráč-přívětivější podmínky než u klasického sticky bonusu.
                  </p>
                </div>

                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4">
                  <div className="font-bold text-[#003da5] text-sm mb-1.5">Bonus bez vkladu a bonusové kódy</div>
                  <p className="text-gray-600 text-sm">
                    Nomini Casino v současné době nenabízí bonus bez nutnosti vkladu. Bonusové kódy kasino nevyužívá – všechny akce lze aktivovat ručně přímo na platformě v sekci „Promo akce".
                  </p>
                </div>
              </div>

              {/* Games */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-2">Hry &amp; Poskytovatelé</h2>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  Nomini Casino se pyšní více než 9 000 hrami od více než 100 poskytovatelů. Nejoblíbenější kategorie: video sloty, stolní hry (blackjack, baccarat, ruleta, poker, bingo, kostky, Sic Bo), hry s živými dealery, jackpoty, stírací losy, crash hry a virtuální sporty. Jakoukoli hru lze spustit v demo režimu.
                </p>

                <div className="grid sm:grid-cols-2 gap-3 mb-4">
                  {[
                    ["Výherní automaty",       "8 500+ – video sloty, jackpoty, bonusová kola, Megaways"],
                    ["Ruleta",                 "100+ variant – RNG i živá verze"],
                    ["Blackjack",              "100+ variant, 206 živých stolů"],
                    ["Hry s živými dealery",   "270+ přenosů – blackjack, poker, ruleta, baccarat, TV show"],
                    ["Sportovní sázení",       "27 disciplín včetně Live Betting"],
                    ["Crash hry + virtuální",  "Crash hry, stírací losy, virtuální sporty"],
                  ].map(([label, val]) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="font-semibold text-gray-900 text-xs mb-0.5">{label}</div>
                      <div className="text-gray-600 text-xs leading-relaxed">{val}</div>
                    </div>
                  ))}
                </div>

                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4">
                  <div className="font-bold text-[#003da5] text-xs mb-2">Populární poskytovatelé</div>
                  <div className="flex flex-wrap gap-1.5">
                    {["NetEnt", "Play'n GO", "Pragmatic Play", "Evolution", "Microgaming", "Red Tiger", "Nolimit City", "Yggdrasil", "Push Gaming", "Quickspin", "Ezugi", "Hacksaw Gaming", "ELK Studios", "Playson", "Relax Gaming", "Playtech"].map(p => (
                      <span key={p} className="bg-white border border-[#003da5]/15 text-gray-700 text-xs px-2.5 py-1 rounded-full font-medium">{p}</span>
                    ))}
                    <span className="text-gray-400 text-xs self-center">a 80+ dalších</span>
                  </div>
                </div>
              </div>

              {/* VIP */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Věrnostní program, Coins a Obchod odměn</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Provozovatel přináší 5úrovňový věrnostní program. Každý status je hráči přiřazen na základě jeho aktivity a objemu vkladů. Čím je hráč aktivnější – čím častěji vkládá a hraje –, tím více výhod se mu otevírá.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Plněním jednoduchých úkolů spojených s kasinem a sportovním sázením sbíráte mince. Ty pak můžete v interním Obchodě směnit za bonusy, jako jsou sázky zdarma, bonusové peníze nebo free spiny.
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mb-4">
                  {["Bronz", "Stříbro", "Zlato", "Platina", "Diamant"].map((tier, i) => (
                    <div key={tier} className={`rounded-xl p-2.5 text-center border ${i === 4 ? "bg-[#003da5] border-[#003da5] text-white" : "bg-[#f3f6fb] border-[#dde4ee] text-gray-700"}`}>
                      <div className="font-bold text-xs">{tier}</div>
                      <div className={`text-xs mt-0.5 ${i === 4 ? "text-white/70" : "text-gray-400"}`}>Úroveň {i + 1}</div>
                    </div>
                  ))}
                </div>
                <div className="grid sm:grid-cols-3 gap-3">
                  {[
                    { icon: ShoppingBag, label: "Obchod odměn",   desc: "Mince → sázky zdarma, bonusové peníze, free spiny" },
                    { icon: Trophy,      label: "VIP cashback",    desc: "Až 15 % z proher, max 75 000 Kč" },
                    { icon: Zap,         label: "Live cashback",   desc: "25 % cashback pro live casino, max 5 000 Kč" },
                  ].map(({ icon: Icon, label, desc }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="flex items-center gap-1.5 mb-1">
                        <Icon className="w-3.5 h-3.5 text-[#003da5]" />
                        <div className="font-semibold text-gray-900 text-sm">{label}</div>
                      </div>
                      <div className="text-gray-600 text-xs leading-relaxed">{desc}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platební metody</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Nomini sází na bezpečnost a flexibilitu – na výběr máte z 19 metod pro vklad a hned 21 pro výběr, a to vše bez jakýchkoliv poplatků. Peníze jsou na herní účet obvykle připsány okamžitě.
                </p>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-4">
                  {[
                    { label: "Min. vklad (bonus)",   value: "500 Kč" },
                    { label: "Min. vklad (Bonus Crab)", value: "250 Kč" },
                    { label: "Min. výběr",           value: "250 Kč" },
                    { label: "E-wallet / krypto",    value: "Do 24 h (někdy ihned)" },
                    { label: "Karty / bank. převod", value: "2–5 prac. dní" },
                    { label: "Poplatky kasina",      value: "Žádné" },
                  ].map(({ label, value }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="text-gray-500 text-xs mb-0.5">{label}</div>
                      <div className="font-bold text-gray-900 text-xs">{value}</div>
                    </div>
                  ))}
                </div>

                <div className="grid sm:grid-cols-2 gap-4">
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-2">Metody vkladu (19)</div>
                    <div className="flex flex-wrap gap-1">
                      {["Visa", "Mastercard", "Paysafecard", "CashtoCode", "Neosurf", "Skrill", "Neteller", "MiFinity", "eZeeWallet", "EcoPayz", "Bitcoin", "Ethereum", "Litecoin", "Ripple", "USDT"].map(m => (
                        <PaymentLogoPill key={m} name={m} />
                      ))}
                    </div>
                  </div>
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-2">Metody výběru (21)</div>
                    <div className="flex flex-wrap gap-1">
                      {["Visa", "Mastercard", "Skrill", "Neteller", "Skrill 1-Tap", "eZeeWallet", "MiFinity", "Bankovní převod", "Bitcoin", "Litecoin", "Ethereum", "Ripple", "USDT"].map(m => (
                        <PaymentLogoPill key={m} name={m} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Online chat je k dispozici 24/7. Neodpovídá vám bot, ale skuteční operátoři – na odpověď obvykle nečekáte déle než minutu. Odpověď na e-mail trvá přibližně 45 minut, což je ideální pro složitější dotazy nebo zasílání dokumentů.
                </p>
                <div className="grid sm:grid-cols-2 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7 · odpověď do 1 minuty · reální operátoři</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@nomini.com · cca 45 minut</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo20} alt="Nomini" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Nomini Casino</div>
                      <div className="flex items-center gap-0.5">
                        {[1,2,3,4].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <div className="relative w-3 h-3">
                          <Star className="w-3 h-3 text-[#f5c518]/30 absolute inset-0" />
                          <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                            <Star className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />
                          </div>
                        </div>
                        <span className="text-gray-600 text-xs ml-1">9.0/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus (non-sticky)</div>
                    <div className="text-[#003da5] font-black text-xl">až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 FS + Bonus Crab</div>
                    <div className="text-gray-400 text-xs mt-0.5">Wager 35× · Max. sázka 125 Kč</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Calendar,    label: "Rok",              value: "2019" },
                      { icon: Globe,       label: "Provozovatel",     value: "7StarsPartners" },
                      { icon: Lock,        label: "Licence",          value: "Anjouan" },
                      { icon: Gamepad2,    label: "Celkem her",       value: "9 000+" },
                      { icon: Users,       label: "Sporty",           value: "27 disciplín" },
                      { icon: CreditCard,  label: "Min. vklad",       value: "250 Kč" },
                      { icon: Zap,         label: "E-wallet výplata", value: "Do 24 hodin" },
                      { icon: Trophy,      label: "VIP cashback",     value: "Až 15 % (75 000 Kč)" },
                      { icon: ShoppingBag, label: "Obchod odměn",     value: "Coins systém" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="nomini" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/allyspin" className="text-[#003da5] hover:underline" data-testid="review-link-allyspin">Allyspin</a>
              {" · "}
              <a href="/kasina/spinanga" className="text-[#003da5] hover:underline" data-testid="review-link-spinanga">Spinanga</a>
              {" · "}
              <a href="/kasina/spinit" className="text-[#003da5] hover:underline" data-testid="review-link-spinit">SPINiT</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
